<div class="settings-container">

  <h2>
    Podešavanja početne strane
  </h2>

  <label>
    Glavni naslov
  </label>

  <input
    type="text"
    [(ngModel)]="model.heroTitle">

  <label>
    Podnaslov
  </label>

  <input
    type="text"
    [(ngModel)]="model.heroSubtitle">

  <label>
    Opis
  </label>

  <label>
    Slika naslovne sekcije
  </label>

  <input
    type="text"
    [(ngModel)]="model.heroImageUrl">

  <label>
    Tekst dugmeta
  </label>

  <input
    type="text"
    [(ngModel)]="model.heroButtonText">

  <button
    (click)="save()">

    Sačuvaj promene

  </button>
<label>
  Slika naslovne sekcije
</label>

<input
  type="file"
  accept="image/*"
  (change)="onFileSelected($event)">

<img
  *ngIf="model.heroImageUrl"
  [src]="model.heroImageUrl"
  class="preview">
</div>